// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accessibility-bar {
  position: absolute;
  top: 0;
  z-index: 99999 !important;
  width: 100%;
  background: transparent !important;
}

ul.ant-dropdown-menu.ant-dropdown-menu-root.ant-dropdown-menu-vertical.ant-dropdown-menu-light.menu-accessibility {
  background-color: #24a637 !important;
}
ul.ant-dropdown-menu.ant-dropdown-menu-root.ant-dropdown-menu-vertical.ant-dropdown-menu-light.menu-accessibility li.ant-dropdown-menu-item.ant-dropdown-menu-item-only-child.item-accessibility span,
ul.ant-dropdown-menu.ant-dropdown-menu-root.ant-dropdown-menu-vertical.ant-dropdown-menu-light.menu-accessibility li.ant-dropdown-menu-item.ant-dropdown-menu-item-only-child.item-accessibility a {
  background-color: transparent !important;
}
ul.ant-dropdown-menu.ant-dropdown-menu-root.ant-dropdown-menu-vertical.ant-dropdown-menu-light.menu-accessibility li.ant-dropdown-menu-item.ant-dropdown-menu-item-only-child.item-accessibility:hover {
  background-color: #044f29 !important;
}
ul.ant-dropdown-menu.ant-dropdown-menu-root.ant-dropdown-menu-vertical.ant-dropdown-menu-light.menu-accessibility li.ant-dropdown-menu-item.ant-dropdown-menu-item-only-child.item-accessibility a {
  font-family: "Roboto" !important;
  color: #fff !important;
}

.accessibility-content {
  margin: 0 auto;
  width: calc(100% - 30vw) !important;
  background: rgba(0, 0, 0, 0.15) !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.accessibility-content .accessibitity-actions {
  display: flex;
  align-items: center;
}
.accessibility-content .accessibitity-actions button span {
  font-size: 14px !important;
}
.accessibility-content .accessibitity-actions .accessibitity-title {
  font-size: 14px !important;
  color: #465564;
  font-weight: 600;
  margin-right: 10px;
}
.accessibility-content .accessibitity-actions .accessibitity-action-button {
  height: 30px;
  width: 30px;
  text-align: center;
  border: none !important;
  box-shadow: none !important;
  border-radius: 7px !important;
  padding: 0 !important;
  font-weight: bold;
  color: #fff;
  background-color: transparent !important;
}
.accessibility-content .accessibitity-actions .accessibitity-action-button span {
  font-size: 18px !important;
}
.accessibility-content .accessibitity-actions .libras {
  padding: 0 4px !important;
}
.accessibility-content ul {
  display: flex;
  margin: 0;
}
.accessibility-content ul li {
  list-style: none;
  border-right: 1px solid #fff;
}
.accessibility-content ul li a {
  text-decoration: none;
  font-weight: bold;
  display: flex;
  align-items: center;
  color: #fff;
  padding-left: 5px;
  padding-right: 5px;
  text-transform: uppercase;
  font-size: 10px;
}
.accessibility-content ul li a svg {
  width: 25px;
}
.accessibility-content li:last-child {
  border-right: none;
}
.accessibility-content li:last-child a {
  padding-right: 0 !important;
}

@media (max-width: 660px) {
  .accessibility-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0px !important;
  }
  .accessibility-content ul {
    padding: 10px !important;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .accessibility-content ul li {
    text-align: center;
    margin: 0 auto !important;
    font-size: 12px !important;
    width: 100%;
  }
}
@media (max-width: 480px) {
  .accessibility-content ul {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 10px !important;
  }
  .accessibility-content ul li {
    text-align: center;
    margin: 0 auto !important;
    font-size: 12px !important;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/UI/AccessibilityBar/accessibilityBar.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,MAAA;EACA,yBAAA;EACA,WAAA;EACA,kCAAA;AACF;;AACA;EACE,oCAAA;AAEF;AACI;;EAEE,wCAAA;AACN;AAEI;EACE,oCAAA;AAAN;AAGE;EAEE,gCAAA;EACA,sBAAA;AAFJ;;AAKA;EACE,cAAA;EACA,mCAAA;EACA,0CAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAFF;AAKE;EACE,aAAA;EACA,mBAAA;AAHJ;AAII;EACE,0BAAA;AAFN;AAII;EACE,0BAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAFN;AAII;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;EACA,qBAAA;EAEA,iBAAA;EACA,WAAA;EACA,wCAAA;AAHN;AAKM;EACE,0BAAA;AAHR;AAMI;EACE,yBAAA;AAJN;AAOE;EACE,aAAA;EACA,SAAA;AALJ;AAMI;EACE,gBAAA;EACA,4BAAA;AAJN;AAKM;EACE,qBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AAHR;AAKQ;EACE,WAAA;AAHV;AAQE;EACE,kBAAA;AANJ;AAOI;EACE,2BAAA;AALN;;AAUA;EACE;IACE,aAAA;IACA,sBAAA;IACA,YAAA;IACA,uBAAA;EAPF;EASE;IACE,wBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,mBAAA;EAPJ;EASI;IACE,kBAAA;IACA,yBAAA;IACA,0BAAA;IACA,WAAA;EAPN;AACF;AAYA;EAEI;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,wBAAA;EAXJ;EAaI;IACE,kBAAA;IACA,yBAAA;IACA,0BAAA;IACA,WAAA;EAXN;AACF","sourcesContent":[".accessibility-bar {\n  position: absolute;\n  top: 0;\n  z-index: 99999 !important;\n  width: 100%;\n  background: transparent !important;\n}\nul.ant-dropdown-menu.ant-dropdown-menu-root.ant-dropdown-menu-vertical.ant-dropdown-menu-light.menu-accessibility {\n  background-color: #24a637 !important;\n\n  li.ant-dropdown-menu-item.ant-dropdown-menu-item-only-child.item-accessibility {\n    span,\n    a {\n      background-color: transparent !important;\n    }\n\n    &:hover {\n      background-color: #044f29 !important ;\n    }\n  }\n  li.ant-dropdown-menu-item.ant-dropdown-menu-item-only-child.item-accessibility\n    a {\n    font-family: 'Roboto' !important;\n    color: #fff !important;\n  }\n}\n.accessibility-content {\n  margin: 0 auto;\n  width: calc(100% - 30vw) !important;\n  background: rgba(0, 0, 0, 0.15) !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  // font-family: 'Nunito', sans-serif !important;\n  .accessibitity-actions {\n    display: flex;\n    align-items: center;\n    button span {\n      font-size: 14px !important;\n    }\n    .accessibitity-title {\n      font-size: 14px !important;\n      color: #465564;\n      font-weight: 600;\n      margin-right: 10px;\n    }\n    .accessibitity-action-button {\n      height: 30px;\n      width: 30px;\n      text-align: center;\n      border: none !important;\n      box-shadow: none !important;\n      border-radius: 7px !important;\n      padding: 0 !important;\n      // margin-right: 10px;\n      font-weight: bold;\n      color: #fff;\n      background-color: transparent !important;\n\n      span {\n        font-size: 18px !important;\n      }\n    }\n    .libras {\n      padding: 0 4px !important;\n    }\n  }\n  ul {\n    display: flex;\n    margin: 0;\n    li {\n      list-style: none;\n      border-right: 1px solid #fff;\n      a {\n        text-decoration: none;\n        font-weight: bold;\n        display: flex;\n        align-items: center;\n        color: #fff;\n        padding-left: 5px;\n        padding-right: 5px;\n        text-transform: uppercase;\n        font-size: 10px;\n\n        svg {\n          width: 25px;\n        }\n      }\n    }\n  }\n  li:last-child {\n    border-right: none;\n    a {\n      padding-right: 0 !important;\n    }\n  }\n}\n\n@media (max-width: 660px) {\n  .accessibility-content {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    padding: 0px !important;\n\n    ul {\n      padding: 10px !important;\n      display: flex;\n      flex-direction: row;\n      justify-content: center;\n      align-items: center;\n\n      li {\n        text-align: center;\n        margin: 0 auto !important;\n        font-size: 12px !important;\n        width: 100%;\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .accessibility-content {\n    ul {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: center;\n      padding: 10px !important;\n\n      li {\n        text-align: center;\n        margin: 0 auto !important;\n        font-size: 12px !important;\n        width: 100%;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
